import React from 'react';
import classnames from 'classnames';

import { SvgRoundedHorizontal } from './SvgRoundedHorizontal';

interface SvgRounedBottomProps {
  color: string;
  height?: number;
  width?: number;
  /**
   * Modifies where the highest point of the rounded bottom is.
   * Should be between 0 and 1
   */
  bezierShift?: number;
  className?: string;
}

interface SvgRounedBottomOutcavedProps {
  height?: number;
  className?: string;
}
export const SvgRounedBottomOutcaved: React.FC<SvgRounedBottomOutcavedProps> = ({
  height = 40,
  ...props
}) => (
  <svg
    width="500"
    height={height}
    viewBox={`0 0 500 ${height}`}
    fill="none"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      d={`M0,${height} L0,00 Q250,${height * 2} 500,0 L500,${height} Z`}
      fill="currentColor"
    ></path>
  </svg>
);

export const SvgRounedBottom: React.FC<SvgRounedBottomProps> = props => (
  <SvgRoundedHorizontal {...props} placement="bottom" />
);

export const WrappedRounedBottom: React.FC = props => (
  <div className="position-relative d-inline-block">
    {props.children}
    <div className="shape shape-bottom shape-fluid-x svg-shim text-light">
      <SvgRounedBottomOutcaved className="w-100" />
    </div>
  </div>
);
